import {tap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AuthCoreService} from './auth-core.service';
import { estRequeteHorsCache } from '../utils/functions';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
	constructor(private authService: AuthCoreService) {
	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		if (/nuxeo/.test(request.url)) {
			// Permet de communiquer avec la GED en rajoutant le token de Nuxeo dans le header d'authentification.
			request = request.clone({
				setHeaders: {
					Authorization: this.authService.getTokenGed()
				}
			});

			return next.handle(request);
		}
		request = request.clone({
			setHeaders: {
				Authorization: this.authService.getToken()
			}
		});

		return next.handle(request).pipe(tap(evt => {
			// S'il s'agit d'une réponse, on renouvelle le token d'authentification dans 2 cas :
			// - La requête est une requête de connexion.
			// - Le token est enregistré dans le localstorage (l'utilisateur est déjà connecté) et la requête ne concerne pas une ressource dans le cache
			if (evt instanceof HttpResponse && (/\/ws\/auth/.test(evt.url) || (localStorage.getItem('access_token') && estRequeteHorsCache(evt.headers)))) {
				this.authService.saveToken(evt.headers);
			}
		}));
	}
}
